<ng-container *cdkPortal>
  <section
    [attr.role]="role()"
    class="tw-w-[23rem] tw-sticky tw-top-0 tw-h-screen tw-flex tw-flex-col tw-overflow-auto tw-border-0 tw-border-l tw-border-solid tw-border-secondary-300 tw-bg-background"
  >
    <ng-content></ng-content>
  </section>
</ng-container>
